import { Interval } from '@taxfyle/api-internal/shared/types/interval_pb'
import { addMinutes, isBefore, areIntervalsOverlapping } from 'date-fns'
import { makeObservable, observable } from 'mobx'
import { maybeParseDate } from 'utils/date-util'
import { timestampToISO } from 'utils/grpc-util'

export class TimeRange {
  startTime: Date

  endTime: Date

  constructor(startTime: Date, endTime: Date) {
    this.startTime = startTime
    this.endTime = endTime
    makeObservable(this, {
      startTime: observable,
      endTime: observable,
    })
  }

  isEqual(range: TimeRange) {
    return (
      range.startTime.getHours() === this.startTime.getHours() &&
      range.startTime.getMinutes() === this.startTime.getMinutes() &&
      range.startTime.getDay() === this.startTime.getDay()
    )
  }

  isWithin(range: TimeRange) {
    return areIntervalsOverlapping(
      {
        start: range.startTime,
        end: range.endTime,
      },
      {
        start: this.startTime,
        end: this.endTime,
      },
    )
  }

  decomposeRangeInIntervals(intervalInMinutes: number) {
    let cursor = new Date(this.startTime)
    const intervals = []
    while (isBefore(cursor, this.endTime)) {
      const end = addMinutes(cursor, intervalInMinutes)
      intervals.push(new TimeRange(cursor, end))
      cursor = end
    }
    return intervals
  }

  static fromInterval(interval?: Interval.AsObject) {
    return new TimeRange(
      maybeParseDate(timestampToISO(interval?.startTime)) ?? new Date(),
      maybeParseDate(timestampToISO(interval?.endTime)) ?? new Date(),
    )
  }
}
